/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
    import * as helper from "../../js/helper";
	import like_component from "../components/like-component.vue";
    const __vue_script__ ={
        components: {
            like_component:like_component,
        },
		name:'property_component',
        props: {
            property: {
                type: Object,
            },
            for_mashro: {
                default: false,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading: false,
                ad_type_color: '#0000ff',
                ad_type_color_wt: '#0000ff',
                property_type_icon: '#0000ff',
                creation_date: new Date(),
                url:"",
			};
		},
        mounted(){
            let domain = (new URL(window.location.href));
            url = domain.hostname;
            this.is_loading = true;
            this.creation_date = new Date(this.property.creation);
            this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];
            this.ad_type_color_wt = global.global_params.ad_type_colors[this.property.ad_type]+"aa";
            this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];
            if(this.property.children_property_types){
                this.property.children_property_types_list = this.property.children_property_types.split(',')
            }
            console.log(this.property); 
            this.is_loading = false;
            global.emitter.emit("refresh-tooltips");
        },
		methods: {
			check_enabled: function(field){
				if (this.property.property_type=="")
					return false;
				return this.enabled_fields.includes(field);
			},
            async checkNafath(){
                if(this.property.own && this.for_mashro){
                    this.askPublishProperty();
                    return;
                }
                if(frappe.user_roles.includes("Member") && this.property.for_agency){
                    this.askPublishProperty();
                    return;
                }
                global.emitter.emit("show-full-loading");
				try {
					let params = {};
					let res = await $.ajax({
						headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
						url: "/api/method/maalek.api.is_nafath_verified",
						type: "GET",
						data: params,
					});
					if (res.message == false) {
                        global.emitter.emit("set-onsuccess-func",()=>{
                            $('#nafaz-verification-modal').modal('hide');
                            this.askPublishProperty();
                        });
						$('#nafaz-verification-modal').modal('show');
					}else{
                        this.askPublishProperty();
                    }
				} catch (error) {
					this.exceptions = helper.showException(error);
				}
                global.emitter.emit("hide-full-loading");
            },
            askPublishProperty(){
                if(this.loading || !frappe.session_user || frappe.session_user == "Guest")
                    return;
                bootbox.confirm({
                    message: `<div class="alert alert-info" role="alert">
                        `+helper.t("Do you want to publish?")+`
                    </div>`,
                    buttons: {
                        confirm: {
                            label: helper.t("Yes"),
                            className: 'btn-success'
                        },
                        cancel: {
                            label: helper.t("No"),
                            className: 'btn-danger'
                        }
                    },
                    backdrop: true,
                    callback: (results) => results?this.publishProperty():console.log("cancel"),
                });
            },
            async publishProperty(){
                this.loading = true;
                let params = {
                    property_name : this.property.parent_property?this.property.parent_property:this.property.name,
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.publish",
                        type: "POST",
                        // data: params //for GET request
                        data: JSON.stringify(params) //for POST request
                    });
                    helper.showSuccess("Property published",()=>{
                        location.reload();
                    });
                } catch (e) {
                    console.log(e);
                    var exceptions = helper.showException(e);
                }
                this.loading = false
            },
            askLockProperty(){
                if(this.loading || !frappe.session_user || frappe.session_user == "Guest")
                    return;
                bootbox.confirm({
                    message: `<div class="alert alert-danger" role="alert">
                        <b>`+helper.t("Warning: you cannot undo this action.")+`</b><br>
                        `+helper.t("Do you want to lock this property permanently?")+`
                    </div>`,
                    buttons: {
                        confirm: {
                            label: helper.t("Yes"),
                            className: 'btn-success'
                        },
                        cancel: {
                            label: helper.t("No"),
                            className: 'btn-danger'
                        }
                    },
                    backdrop: true,
                    callback: (results) => results?this.LockProperty():console.log("cancel"),
                });
            },
            async lockProperty (){
                this.form_sent = true;
                let params = {
                    property_name : this.property.parent_property?this.property.parent_property:this.property.name,
                    reason: "Lock"
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.unpublish",
                        type: "POST",
                        // data: params //for GET request
                        data: JSON.stringify(params) //for POST request
                    });
                    this.loading = false
                    global.emitter.emit("refresh-tanent");
                    helper.showSuccess("Property locked permanenetly",()=>{
                        location.reload();
                    });
                } catch (e) {
                    this.error = true;
                    this.exceptions = helper.showException(e);
                }
                this.loading = false
            },
            askUnpublishProperty(){
                if(this.loading || !frappe.session_user || frappe.session_user == "Guest")
                    return;
                bootbox.confirm({
                    message: `<div class="alert alert-danger" role="alert">
                        `+this.for_mashro?helper.t("Do you want to unpublish this property from project?"):helper.t("Do you want to unpublish this property?")+`
                    </div>`,
                    buttons: {
                        confirm: {
                            label: helper.t("Yes"),
                            className: 'btn-success'
                        },
                        cancel: {
                            label: helper.t("No"),
                            className: 'btn-danger'
                        }
                    },
                    backdrop: true,
                    callback: (results) => results?this.unpublishProperty():console.log("cancel"),
                });
            },
            async unpublishProperty (){
                this.form_sent = true;
                let params = {
                    property_name : this.property.parent_property?this.property.parent_property:this.property.name,
                    reason: this.for_mashro?"Mashro":""
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.unpublish",
                        type: "POST",
                        // data: params //for GET request
                        data: JSON.stringify(params) //for POST request
                    });
                    this.loading = false
                    global.emitter.emit("refresh-tanent");
                    helper.showSuccess("Property locked permanenetly",()=>{
                        location.reload();
                    });
                } catch (e) {
                    this.error = true;
                    this.exceptions = helper.showException(e);
                }
                this.loading = false
            },
		},
		computed:{
            enabled_fields(){
                var fields = global.property_constants.property_types[this.property.property_type];
                global.property_constants.remove_field[this.property.ad_type].forEach(field => {
                    const index = fields.indexOf(field);
                    if (index > -1) { // only splice array when item is found
                        fields.splice(index, 1); // 2nd parameter means remove one item only
                    }
                });
                if(this.is_child){
                    global.property_constants.remove_child_field.forEach(field => {
                        const index = fields.indexOf(field);
                        if (index > -1) { // only splice array when item is found
                            fields.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    });
                }
                return fields;
            }
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "single-properties-item animate__animated animate__fadeInUp delay-0-2s"
    },
    [
      _c("div", { staticClass: "col-sm-12 properties-img mb-1" }, [
        _c("div", { staticClass: "row py-1" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "actions d-flex px-1" },
              [
                _c(
                  "p",
                  {
                    staticClass: "flex-grow-1 text-start",
                    attrs: { dir: "ltr" }
                  },
                  [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.creation_date.getDate() +
                            "-" +
                            _vm.global.global_params.months[
                              _vm.creation_date.getMonth()
                            ] +
                            "-" +
                            _vm.creation_date
                              .getYear()
                              .toString()
                              .substr(1)
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.property.own && !_vm.for_mashro
                  ? [
                      !_vm.property.locked
                        ? [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "/account/edit-property/" +
                                    _vm.property.name
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-pen-to-square",
                                  attrs: {
                                    "data-bs-toggle": "tooltip",
                                    "data-bs-placement": "top",
                                    title: _vm.helper.t("Edit")
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.property.published
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "#",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#unpublishModal",
                                      "data-bs-property-name": _vm.property.name
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-circle-xmark",
                                      attrs: {
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-placement": "top",
                                        title: _vm.helper.t("Unpublish")
                                      }
                                    })
                                  ]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.checkNafath()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-circle-check",
                                      attrs: {
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-placement": "top",
                                        title: _vm.helper.t("Publish")
                                      }
                                    })
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.property.member != _vm.frappe.session_user &&
                            _vm.frappe.user_roles.includes("Agency")
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "#",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target":
                                        "#transfer-property-modal",
                                      "data-bs-property-name":
                                        _vm.property.name,
                                      "data-bs-member-name": _vm.property.member
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-shuffle",
                                      attrs: {
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-placement": "top",
                                        title: _vm.helper.t("Transfer Property")
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.property.published
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "#",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#share-property-modal",
                                      "data-bs-property-name": _vm.property.name
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-share-nodes",
                                      attrs: {
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-placement": "top",
                                        title: _vm.helper.t("Share")
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.property.published
                              ? _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.askLockProperty()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-lock",
                                      attrs: {
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-placement": "top",
                                        title: _vm.helper.t("Lock")
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        : [
                            _vm.property.ad_type == "Rent"
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "#",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#addExpenseModal",
                                      "data-bs-property-name": _vm.property.name
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-solid fa-money-bill-wave",
                                      attrs: {
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-placement": "top",
                                        title: _vm.helper.t("Add Expense")
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.property.member != _vm.frappe.session_user &&
                            _vm.frappe.user_roles.includes("Agency")
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "#",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target":
                                        "#transfer-property-modal",
                                      "data-bs-property-name":
                                        _vm.property.name,
                                      "data-bs-member-name": _vm.property.member
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-shuffle",
                                      attrs: {
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-placement": "top",
                                        title: _vm.helper.t("Transfer")
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                    ]
                  : _vm.for_mashro && _vm.property.own == 1
                  ? [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "/account/edit-property/" + _vm.property.name
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa-solid fa-pen-to-square",
                            attrs: {
                              "data-bs-toggle": "tooltip",
                              "data-bs-placement": "top",
                              title: _vm.helper.t("Edit")
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.property.published
                        ? _c(
                            "a",
                            {
                              attrs: { role: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.askUnpublishProperty()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-circle-xmark",
                                attrs: {
                                  "data-bs-toggle": "tooltip",
                                  "data-bs-placement": "top",
                                  title: _vm.helper.t("Unpublish")
                                }
                              })
                            ]
                          )
                        : _c(
                            "a",
                            {
                              attrs: { role: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.checkNafath()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-circle-check",
                                attrs: {
                                  "data-bs-toggle": "tooltip",
                                  "data-bs-placement": "top",
                                  title: _vm.helper.t("Publish")
                                }
                              })
                            ]
                          )
                    ]
                  : [
                      _c("a", { attrs: { role: "button" } }, [
                        _c("i", {
                          staticClass: "fa-solid fa-flag",
                          attrs: {
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#reportModal",
                            "data-bs-property-name": _vm.property["name"]
                          }
                        })
                      ])
                    ],
                _vm._v(" "),
                !_vm.for_mashro
                  ? _c("like_component", {
                      attrs: { property_data: _vm.property }
                    })
                  : _vm._e()
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        !_vm.property.locked || _vm.property.own == 1
          ? _c("a", {
              staticClass: "image-holder",
              style: {
                "background-image":
                  "url(/" +
                  encodeURIComponent(_vm.property.image.substr(1)) +
                  ")"
              },
              attrs: { href: "/property/" + _vm.property.name }
            })
          : _c("a", {
              staticClass: "image-holder",
              style: {
                "background-image":
                  "url(/" +
                  encodeURIComponent(_vm.property.image.substr(1)) +
                  ")"
              }
            }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "top fw-bold text-black",
            class: _vm.frappe.lang_dir == "ltr" ? "left" : "right",
            style: { "background-color": _vm.ad_type_color_wt }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.helper.t(_vm.property.ad_type)) +
                "\n                "
            ),
            _vm.property["total_price"] > 0
              ? [
                  _vm._v("\n                    ("),
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.helper.nFormatter(_vm.property["total_price"]))
                    )
                  ]),
                  _vm._v(")\n                ")
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.property.own == 1
          ? _c(
              "span",
              {
                staticClass: "actions bottom",
                class: _vm.frappe.lang_dir == "ltr" ? "left" : "right",
                staticStyle: { "background-color": "#ffffff99" }
              },
              [
                _vm.property.expired
                  ? _c("a", [
                      _c("i", {
                        staticClass: "fa-solid fa-calendar-xmark text-danger",
                        attrs: {
                          "data-bs-toggle": "tooltip",
                          "data-bs-placement": "top",
                          title: _vm.helper.t("Ad Expired")
                        }
                      })
                    ])
                  : _vm.property.locked
                  ? _c("a", [
                      _c("i", {
                        staticClass: "fa-solid fa-lock",
                        attrs: {
                          "data-bs-toggle": "tooltip",
                          "data-bs-placement": "top",
                          title: _vm.helper.t("Locked / Removed")
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.property.locked && !_vm.property.published
                  ? _c("a", [
                      _c("i", {
                        staticClass: "fa-solid fa-circle-xmark",
                        attrs: {
                          "data-bs-toggle": "tooltip",
                          "data-bs-placement": "top",
                          title: _vm.helper.t("Unpublished")
                        }
                      })
                    ])
                  : _vm.property.published
                  ? _c("a", [
                      _c("i", {
                        staticClass: "fa-solid fa-circle-check",
                        attrs: {
                          "data-bs-toggle": "tooltip",
                          "data-bs-placement": "top",
                          title: _vm.helper.t("Published")
                        }
                      })
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "properties-content" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("h3", [_vm._v(_vm._s(_vm.helper.t(_vm.property.property_type)))]),
          _vm._v(" "),
          _c("small", { staticClass: "fw-bold text-primary" }, [
            _vm._v(_vm._s(_vm.property.name))
          ])
        ]),
        _vm._v(" "),
        _vm.property.member
          ? _c(
              "small",
              {
                staticClass: "text-info",
                attrs: {
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "top",
                  title: _vm.helper.t("Managed By")
                }
              },
              [
                _c("i", { staticClass: "fa-solid fa-briefcase" }),
                _vm._v(" "),
                _c("span", { staticClass: "ms-0" }, [
                  _vm._v(_vm._s(_vm.property.member_full_name))
                ]),
                _vm._v(" "),
                _c("br")
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "\n                " +
              _vm._s(_vm.property.location_address) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "justify-content-start px-0 m-0" }, [
          _vm.check_enabled("no_bed") && _vm.property.no_bed > 0
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Bedrooms"),
                    "data-bs-trigger": "hover"
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-lg fa-door-closed" }),
                  _vm._v(
                    " " + _vm._s(_vm.property.no_bed) + "\n                "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("no_living") && _vm.property.no_living > 0
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Livingrooms"),
                    "data-bs-trigger": "hover"
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-lg fa-tv" }),
                  _vm._v(
                    " " + _vm._s(_vm.property.no_living) + "\n                "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("no_bath") && _vm.property.no_bath > 0
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("Bathrooms"),
                    "data-bs-trigger": "hover"
                  }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-lg fa-bath" }),
                  _vm._v(
                    " " + _vm._s(_vm.property.no_bath) + "\n                "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_water") && _vm.property.is_water
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_water"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-droplet" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_power") && _vm.property.is_power
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_power"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-plug" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_family") && _vm.property.is_family
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_family"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-children" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_furnished") && _vm.property.is_furnished
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_furnished"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-couch" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_kitchen") && _vm.property.is_kitchen
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_kitchen"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-sink" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_air_conditioners") &&
          _vm.property.is_air_conditioners
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_air_conditioners"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-snowflake" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_elevator") && _vm.property.is_elevator
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_elevator"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-elevator" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.check_enabled("is_parking") && _vm.property.is_parking
            ? _c(
                "li",
                {
                  staticClass: "badge bg-light text-dark position-relative",
                  attrs: {
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.helper.t("is_parking"),
                    "data-bs-trigger": "hover"
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-lg fa-square-parking" })]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-768ec2a0_0", { source: "\n.icon{\n    width:10%;\n}\n.properties-img .image-holder{\n    display: block;\n    padding-top: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/components/property-component.vue"],"names":[],"mappings":";AAuYA;IACA,SAAA;AACA;AACA;IACA,cAAA;IACA,iBAAA;IACA,4BAAA;IACA,sBAAA;IACA,2BAAA;AACA","file":"property-component.vue","sourcesContent":["<template>\r\n\t<div class=\"single-properties-item animate__animated animate__fadeInUp delay-0-2s\">\r\n        <div class=\"col-sm-12 properties-img mb-1\">\r\n            <div class=\"row py-1\">\r\n                <div class=\"col-12\">\r\n                    <div class=\"actions d-flex px-1\">\r\n                        <p dir=\"ltr\" class=\"flex-grow-1 text-start\">\r\n                            <b>{{ creation_date.getDate() + \"-\" + global.global_params.months[creation_date.getMonth()] + \"-\" + creation_date.getYear().toString().substr(1) }}</b>\r\n                        </p>\r\n                        <template v-if=\"property.own && !for_mashro\" @click.prevent=\"reupdate()\">\r\n                            <template v-if=\"!property.locked\">\r\n                                <a :href=\"'/account/edit-property/'+property.name\">\r\n                                    <i class=\"fa-solid fa-pen-to-square\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Edit')\"></i>\r\n                                </a>\r\n                                <a v-if=\"property.published\" href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#unpublishModal\" :data-bs-property-name='property.name'>\r\n                                    <i class=\"fa-solid fa-circle-xmark\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Unpublish')\"></i>\r\n                                </a>\r\n                                <a v-else role=\"button\" \r\n                                    @click.prevent=\"checkNafath()\">\r\n                                    <i class=\"fa-solid fa-circle-check\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Publish')\"></i>\r\n                                </a> \r\n                                <a v-if=\"property.member != frappe.session_user && frappe.user_roles.includes('Agency')\" href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#transfer-property-modal\" :data-bs-property-name='property.name' :data-bs-member-name='property.member'>\r\n                                    <i class=\"fa-solid fa-shuffle\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Transfer Property')\"></i>\r\n                                </a>\r\n                                <a v-if=\"property.published\" href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#share-property-modal\" :data-bs-property-name='property.name'>\r\n                                    <i class=\"fa-solid fa-share-nodes\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Share')\"></i>\r\n                                </a>\r\n                                <a v-if=\"!property.published\" role=\"button\" @click.prevent=\"askLockProperty()\">\r\n                                    <i class=\"fa-solid fa-lock\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Lock')\"></i>\r\n                                </a>\r\n                            </template>\r\n                            <template v-else>\r\n                                <a v-if=\"property.ad_type=='Rent'\" href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#addExpenseModal\" :data-bs-property-name='property.name'>\r\n                                    <i class=\"fa-solid fa-money-bill-wave\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Add Expense')\"></i>\r\n                                </a>\r\n                                <a v-if=\"property.member != frappe.session_user && frappe.user_roles.includes('Agency')\" href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#transfer-property-modal\" :data-bs-property-name='property.name' :data-bs-member-name='property.member'>\r\n                                    <i class=\"fa-solid fa-shuffle\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Transfer')\"></i>\r\n                                </a>\r\n                            </template>\r\n                        </template>\r\n                        <template v-else-if=\"for_mashro && property.own == 1\">\r\n                            <a :href=\"'/account/edit-property/'+property.name\">\r\n                                <i class=\"fa-solid fa-pen-to-square\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Edit')\"></i>\r\n                            </a>\r\n                            <a v-if=\"property.published\" role=\"button\" \r\n                                @click.prevent=\"askUnpublishProperty()\">\r\n                                <i class=\"fa-solid fa-circle-xmark\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Unpublish')\"></i>\r\n                            </a>\r\n                            <a v-else role=\"button\" \r\n                                @click.prevent=\"checkNafath()\">\r\n                                <i class=\"fa-solid fa-circle-check\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Publish')\"></i>\r\n                            </a> \r\n                        </template>\r\n                        <template v-else>\r\n                            <a role=\"button\">\r\n                                <i class=\"fa-solid fa-flag\"\r\n                                    data-bs-toggle=\"modal\" data-bs-target=\"#reportModal\" :data-bs-property-name=\"property['name']\"\r\n                                ></i>\r\n                            </a>\r\n                        </template>\r\n                        <like_component v-if=\"!for_mashro\"\r\n                            :property_data=\"property\"\r\n                        ></like_component>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <a v-if=\"!property.locked || property.own == 1\" class=\"image-holder\"\r\n                :href=\"'/property/'+property.name\"\r\n                :style=\"{ 'background-image': `url(/${encodeURIComponent(property.image.substr(1))})` }\">\r\n            </a>\r\n            <a v-else  class=\"image-holder\"\r\n                :style=\"{ 'background-image': `url(/${encodeURIComponent(property.image.substr(1))})`, }\">\r\n            </a>\r\n            <span class=\"top fw-bold text-black\" :class=\"frappe.lang_dir=='ltr'?'left':'right'\" :style=\"{'background-color':ad_type_color_wt}\">\r\n                {{ helper.t(property.ad_type) }}\r\n                <template v-if=\"property['total_price'] > 0\">\r\n                    (<small>{{ helper.nFormatter(property['total_price']) }}</small>)\r\n                </template>\r\n            </span>\r\n            <span v-if=\"property.own == 1\" class=\"actions bottom\" :class=\"frappe.lang_dir=='ltr'?'left':'right'\" style=\"background-color: #ffffff99;\">\r\n                <a v-if=\"property.expired\">\r\n                    <i class=\"fa-solid fa-calendar-xmark text-danger\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Ad Expired')\"></i>\r\n                </a>\r\n                <a v-else-if=\"property.locked\">\r\n                    <i class=\"fa-solid fa-lock\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Locked / Removed')\"></i>\r\n                </a>\r\n                <a v-if=\"!property.locked && !property.published\">\r\n                    <i class=\"fa-solid fa-circle-xmark\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Unpublished')\"></i>\r\n                </a>\r\n                <a v-else-if=\"property.published\">\r\n                    <i class=\"fa-solid fa-circle-check\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Published')\"></i>\r\n                </a>\r\n            </span>\r\n        </div>\r\n        <div class=\"properties-content\">\r\n            <div class=\"d-flex justify-content-between\">\r\n                <h3>{{ helper.t(property.property_type) }}</h3>\r\n                <small class=\"fw-bold text-primary\">{{ property.name }}</small>\r\n                <!-- <h3 v-if=\"property.yearly_price > 0\" class=\"price\">SR {{ property.yearly_price }}</h3> -->\r\n            </div>\r\n            <small v-if=\"property.member\" class=\"text-info\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Managed By')\">\r\n                <i class=\"fa-solid fa-briefcase\"></i>\r\n                <span class=\"ms-0\">{{  property.member_full_name  }}</span>\r\n                <br>\r\n            </small>\r\n            <small>\r\n                {{ property.location_address }}\r\n            </small>\r\n            <ul class=\"justify-content-start px-0 m-0\">\r\n                <li v-if=\"check_enabled('no_bed') && property.no_bed > 0\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Bedrooms')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-door-closed\"></i> {{property.no_bed}}\r\n                </li>\r\n                <li v-if=\"check_enabled('no_living') && property.no_living > 0\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Livingrooms')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-tv\"></i> {{property.no_living}}\r\n                </li>\r\n                <li v-if=\"check_enabled('no_bath') && property.no_bath > 0\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Bathrooms')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-bath\"></i> {{property.no_bath}}\r\n                </li>\r\n                <li v-if=\"check_enabled('is_water') && property.is_water\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_water')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-droplet\"></i>\r\n                </li>\r\n                <li v-if=\"check_enabled('is_power') && property.is_power\" class=\"badge bg-light text-dark\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_power')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-plug\"></i>\r\n                </li>\r\n                <li v-if=\"check_enabled('is_family') && property.is_family\" class=\"badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_family')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-children\"></i>\r\n                </li>\r\n                <li v-if=\"check_enabled('is_furnished') && property.is_furnished\" class=\"badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_furnished')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-couch\"></i>\r\n                </li>\r\n                <li v-if=\"check_enabled('is_kitchen') && property.is_kitchen\" class=\"badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_kitchen')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-sink\"></i>\r\n                </li>\r\n                <li v-if=\"check_enabled('is_air_conditioners') && property.is_air_conditioners\" class=\"badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_air_conditioners')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-snowflake\"></i>\r\n                </li>\r\n                <li v-if=\"check_enabled('is_elevator') && property.is_elevator\" class=\"badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_elevator')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-elevator\"></i>\r\n                </li>\r\n                <li v-if=\"check_enabled('is_parking') && property.is_parking\" class=\"badge bg-light text-dark position-relative\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('is_parking')\" data-bs-trigger=\"hover\">\r\n                    <i class=\"fa-solid fa-lg fa-square-parking\"></i>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\n    import * as global from \"../../js/global\" ;\r\n    import * as helper from \"../../js/helper\";\r\n\timport like_component from \"../components/like-component.vue\";\r\n    export default{\r\n        components: {\r\n            like_component:like_component,\r\n        },\r\n\t\tname:'property_component',\r\n        props: {\r\n            property: {\r\n                type: Object,\r\n            },\r\n            for_mashro: {\r\n                default: false,\r\n            },\r\n        },\r\n\t\tdata() {\r\n\t\t\treturn {\r\n                global,\r\n                helper,\r\n                frappe,\r\n                is_loading: false,\r\n                ad_type_color: '#0000ff',\r\n                ad_type_color_wt: '#0000ff',\r\n                property_type_icon: '#0000ff',\r\n                creation_date: new Date(),\r\n                url:\"\",\r\n\t\t\t};\r\n\t\t},\r\n        mounted(){\r\n            let domain = (new URL(window.location.href));\r\n            url = domain.hostname;\r\n            this.is_loading = true;\r\n            this.creation_date = new Date(this.property.creation);\r\n            this.ad_type_color = global.global_params.ad_type_colors[this.property.ad_type];\r\n            this.ad_type_color_wt = global.global_params.ad_type_colors[this.property.ad_type]+\"aa\";\r\n            this.property_type_icon = global.global_params.map_icons[this.property.property_type][this.property.ad_type];\r\n            if(this.property.children_property_types){\r\n                this.property.children_property_types_list = this.property.children_property_types.split(',')\r\n            }\r\n            console.log(this.property); \r\n            this.is_loading = false;\r\n            global.emitter.emit(\"refresh-tooltips\");\r\n        },\r\n\t\tmethods: {\r\n\t\t\tcheck_enabled: function(field){\r\n\t\t\t\tif (this.property.property_type==\"\")\r\n\t\t\t\t\treturn false;\r\n\t\t\t\treturn this.enabled_fields.includes(field);\r\n\t\t\t},\r\n            async checkNafath(){\r\n                if(this.property.own && this.for_mashro){\r\n                    this.askPublishProperty();\r\n                    return;\r\n                }\r\n                if(frappe.user_roles.includes(\"Member\") && this.property.for_agency){\r\n                    this.askPublishProperty();\r\n                    return;\r\n                }\r\n                global.emitter.emit(\"show-full-loading\");\r\n\t\t\t\ttry {\r\n\t\t\t\t\tlet params = {};\r\n\t\t\t\t\tlet res = await $.ajax({\r\n\t\t\t\t\t\theaders: { \"X-Frappe-CSRF-Token\": frappe.csrf_token },\r\n\t\t\t\t\t\turl: \"/api/method/maalek.api.is_nafath_verified\",\r\n\t\t\t\t\t\ttype: \"GET\",\r\n\t\t\t\t\t\tdata: params,\r\n\t\t\t\t\t});\r\n\t\t\t\t\tif (res.message == false) {\r\n                        global.emitter.emit(\"set-onsuccess-func\",()=>{\r\n                            $('#nafaz-verification-modal').modal('hide');\r\n                            this.askPublishProperty();\r\n                        });\r\n\t\t\t\t\t\t$('#nafaz-verification-modal').modal('show');\r\n\t\t\t\t\t}else{\r\n                        this.askPublishProperty();\r\n                    }\r\n\t\t\t\t} catch (error) {\r\n\t\t\t\t\tthis.exceptions = helper.showException(error);\r\n\t\t\t\t}\r\n                global.emitter.emit(\"hide-full-loading\");\r\n            },\r\n            askPublishProperty(){\r\n                if(this.loading || !frappe.session_user || frappe.session_user == \"Guest\")\r\n                    return;\r\n                bootbox.confirm({\r\n                    message: `<div class=\"alert alert-info\" role=\"alert\">\r\n                        `+helper.t(\"Do you want to publish?\")+`\r\n                    </div>`,\r\n                    buttons: {\r\n                        confirm: {\r\n                            label: helper.t(\"Yes\"),\r\n                            className: 'btn-success'\r\n                        },\r\n                        cancel: {\r\n                            label: helper.t(\"No\"),\r\n                            className: 'btn-danger'\r\n                        }\r\n                    },\r\n                    backdrop: true,\r\n                    callback: (results) => results?this.publishProperty():console.log(\"cancel\"),\r\n                });\r\n            },\r\n            async publishProperty(){\r\n                this.loading = true;\r\n                let params = {\r\n                    property_name : this.property.parent_property?this.property.parent_property:this.property.name,\r\n                };\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.publish\",\r\n                        type: \"POST\",\r\n                        // data: params //for GET request\r\n                        data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    helper.showSuccess(\"Property published\",()=>{\r\n                        location.reload();\r\n                    });\r\n                } catch (e) {\r\n                    console.log(e);\r\n                    var exceptions = helper.showException(e);\r\n                }\r\n                this.loading = false\r\n            },\r\n            askLockProperty(){\r\n                if(this.loading || !frappe.session_user || frappe.session_user == \"Guest\")\r\n                    return;\r\n                bootbox.confirm({\r\n                    message: `<div class=\"alert alert-danger\" role=\"alert\">\r\n                        <b>`+helper.t(\"Warning: you cannot undo this action.\")+`</b><br>\r\n                        `+helper.t(\"Do you want to lock this property permanently?\")+`\r\n                    </div>`,\r\n                    buttons: {\r\n                        confirm: {\r\n                            label: helper.t(\"Yes\"),\r\n                            className: 'btn-success'\r\n                        },\r\n                        cancel: {\r\n                            label: helper.t(\"No\"),\r\n                            className: 'btn-danger'\r\n                        }\r\n                    },\r\n                    backdrop: true,\r\n                    callback: (results) => results?this.LockProperty():console.log(\"cancel\"),\r\n                });\r\n            },\r\n            async lockProperty (){\r\n                this.form_sent = true;\r\n                let params = {\r\n                    property_name : this.property.parent_property?this.property.parent_property:this.property.name,\r\n                    reason: \"Lock\"\r\n                };\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.unpublish\",\r\n                        type: \"POST\",\r\n                        // data: params //for GET request\r\n                        data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    this.loading = false\r\n                    global.emitter.emit(\"refresh-tanent\");\r\n                    helper.showSuccess(\"Property locked permanenetly\",()=>{\r\n                        location.reload();\r\n                    });\r\n                } catch (e) {\r\n                    this.error = true;\r\n                    this.exceptions = helper.showException(e);\r\n                }\r\n                this.loading = false\r\n            },\r\n            askUnpublishProperty(){\r\n                if(this.loading || !frappe.session_user || frappe.session_user == \"Guest\")\r\n                    return;\r\n                bootbox.confirm({\r\n                    message: `<div class=\"alert alert-danger\" role=\"alert\">\r\n                        `+this.for_mashro?helper.t(\"Do you want to unpublish this property from project?\"):helper.t(\"Do you want to unpublish this property?\")+`\r\n                    </div>`,\r\n                    buttons: {\r\n                        confirm: {\r\n                            label: helper.t(\"Yes\"),\r\n                            className: 'btn-success'\r\n                        },\r\n                        cancel: {\r\n                            label: helper.t(\"No\"),\r\n                            className: 'btn-danger'\r\n                        }\r\n                    },\r\n                    backdrop: true,\r\n                    callback: (results) => results?this.unpublishProperty():console.log(\"cancel\"),\r\n                });\r\n            },\r\n            async unpublishProperty (){\r\n                this.form_sent = true;\r\n                let params = {\r\n                    property_name : this.property.parent_property?this.property.parent_property:this.property.name,\r\n                    reason: this.for_mashro?\"Mashro\":\"\"\r\n                };\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.unpublish\",\r\n                        type: \"POST\",\r\n                        // data: params //for GET request\r\n                        data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    this.loading = false\r\n                    global.emitter.emit(\"refresh-tanent\");\r\n                    helper.showSuccess(\"Property locked permanenetly\",()=>{\r\n                        location.reload();\r\n                    });\r\n                } catch (e) {\r\n                    this.error = true;\r\n                    this.exceptions = helper.showException(e);\r\n                }\r\n                this.loading = false\r\n            },\r\n\t\t},\r\n\t\tcomputed:{\r\n            enabled_fields(){\r\n                var fields = global.property_constants.property_types[this.property.property_type];\r\n                global.property_constants.remove_field[this.property.ad_type].forEach(field => {\r\n                    const index = fields.indexOf(field);\r\n                    if (index > -1) { // only splice array when item is found\r\n                        fields.splice(index, 1); // 2nd parameter means remove one item only\r\n                    }\r\n                });\r\n                if(this.is_child){\r\n                    global.property_constants.remove_child_field.forEach(field => {\r\n                        const index = fields.indexOf(field);\r\n                        if (index > -1) { // only splice array when item is found\r\n                            fields.splice(index, 1); // 2nd parameter means remove one item only\r\n                        }\r\n                    });\r\n                }\r\n                return fields;\r\n            }\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n    .icon{\r\n        width:10%;\r\n    }\r\n    .properties-img .image-holder{\r\n        display: block;\r\n        padding-top: 100%;\r\n        background-repeat: no-repeat;\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/components/property-component.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__